import { supabase } from '../supabaseClient'

export const abacatePayService = {
  async criarPagamentoPix(plano) {
    const { data, error } = await supabase.functions.invoke('abacate-create-pix', {
      body: { plano }
    })
    if (error) throw new Error(error.message || 'Erro ao criar pagamento Pix')
    return data
  },

  async criarAssinatura(plano) {
    const { data, error } = await supabase.functions.invoke('abacate-create-subscription', {
      body: { plano }
    })
    if (error) throw new Error(error.message || 'Erro ao criar assinatura')
    return data
  },

  async cancelarAssinatura() {
    const { data, error } = await supabase.functions.invoke('abacate-cancel-subscription', { body: {} })
    if (error) throw new Error(error.message || 'Erro ao cancelar assinatura')
    return data
  },

  async verificarAssinaturaAtiva() {
    const { data, error } = await supabase
      .from('assinaturas_abacate')
      .select('*')
      .eq('status', 'authorized')
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle()
    if (error && error.code !== 'PGRST116') throw error
    return data || null
  },

  async buscarMeusPagamentos() {
    const { data, error } = await supabase
      .from('pagamentos_abacate')
      .select('*')
      .order('data_pagamento', { ascending: false })
    if (error) throw error
    return data || []
  }
}
